export default __webpack_public_path__ + "static/media/cancel.b2344965.svg";